import { Linkedin, Mail, MapPin, Phone, Twitter } from "lucide-react";

import { Link } from "wouter";
import logo from "../assets/logo.png";

function Foot() {
  return (
    <footer className="bg-[#2b2f36] text-white py-16">
      <div className="mx-auto max-w-7xl px-4">

        {/* Top Grid */}
        <div className="grid gap-10 md:grid-cols-4 mb-12">

          {/* Company Info */}
          <div className="md:col-span-2">
            <img
              src={logo}
              alt="Xstream Minds Logo"
              className="mb-4 h-14 w-auto"
            />

            <p className="mb-6 max-w-md text-gray-300 text-sm leading-relaxed">
              Empowering businesses to accelerate digital transformation through
              data streaming, cloud computing, and AI technologies. We help
              organizations innovate faster and scale efficiently.
            </p>

            {/* Social Icons */}
            <div className="flex gap-4">
              <a
                href="https://www.linkedin.com/company/xstream-minds-pvt-ltd/posts/?feedView=all"
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-10 w-10 items-center justify-center rounded-lg bg-orange-500 hover:bg-white hover:text-orange-500 transition"
              >
                <Linkedin size={20} />
              </a>

              <a
                href="https://x.com/Xstream_Minds"
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-10 w-10 items-center justify-center rounded-lg bg-orange-500 hover:bg-white hover:text-orange-500 transition"
              >
                <Twitter size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="mb-4 text-lg font-semibold">Quick Links</h3>
            <ul className="space-y-2 text-gray-300">
              <li>
                <Link href="/">
                  <a className="hover:text-orange-500">Home</a>
                </Link>
              </li>
              <li>
                <Link href="/services">
                  <a className="hover:text-orange-500">Services</a>
                </Link>
              </li>
              <li>
                <Link href="/about">
                  <a className="hover:text-orange-500">About Us</a>
                </Link>
              </li>
              <li>
                <Link href="/contact">
                  <a className="hover:text-orange-500">Contact</a>
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="mb-4 text-lg font-semibold">Contact</h3>

            <div className="space-y-3 text-gray-300 text-sm">
              <p className="flex items-center">
                <Mail size={16} className="mr-2 text-orange-500" />
                sales@xstreamminds.com
              </p>

              {/* <p className="flex items-center">
                <Phone size={16} className="mr-2 text-orange-500" />
              +1 (636) 298-3168
              </p> */}

              <div className="flex items-start">
  <MapPin size={18} className="mr-2 mt-1 text-orange-500" />

  <p className="leading-relaxed">
    Alt.f CoWorking,
    9th Floor,
    <br />
    Kapil Kavuri Hub, 144, Survey 37,
    <br />
    Financial District, Nanakramguda,
    <br />
    Telangana 500032
  </p>
</div>
             
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-6 text-center text-sm text-gray-400">
         
          <p>
            © 2026 Xstream Minds Pvt Ltd. All rights reserved.
          </p>
        </div>

      </div>
    </footer>
  );
}
export default Foot;